"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementDevicesApi = exports.MeasurementDevicesApiFactory = exports.MeasurementDevicesApiFp = exports.MeasurementDevicesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * MeasurementDevicesApi - axios parameter creator
 * @export
 */
const MeasurementDevicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [deviceIds]
         * @param {string} [topic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceDeviceCurrentCategoryReadings: (deviceIds_1, topic_1, ...args_1) => __awaiter(this, [deviceIds_1, topic_1, ...args_1], void 0, function* (deviceIds, topic, options = {}) {
            const localVarPath = `/measurementDevices/measurementDevicesReadingsByTopic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (deviceIds !== undefined) {
                localVarQueryParameter['deviceIds'] = deviceIds;
            }
            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceGeoMeasurementDevices: (...args_2) => __awaiter(this, [...args_2], void 0, function* (options = {}) {
            const localVarPath = `/measurementDevices/geoMeasurementDevices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [includeDatasets]
         * @param {Array<number>} [tagObjectIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceGetMeasurementDevicesByTags: (includeDatasets_1, tagObjectIds_1, ...args_3) => __awaiter(this, [includeDatasets_1, tagObjectIds_1, ...args_3], void 0, function* (includeDatasets, tagObjectIds, options = {}) {
            const localVarPath = `/measurementDevices/devicesByTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeDatasets !== undefined) {
                localVarQueryParameter['includeDatasets'] = includeDatasets;
            }
            if (tagObjectIds) {
                localVarQueryParameter['tagObjectIds'] = tagObjectIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MeasurementDevicesApiAxiosParamCreator = MeasurementDevicesApiAxiosParamCreator;
/**
 * MeasurementDevicesApi - functional programming interface
 * @export
 */
const MeasurementDevicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MeasurementDevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [deviceIds]
         * @param {string} [topic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceDeviceCurrentCategoryReadings(deviceIds, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.measurementDeviceResourceDeviceCurrentCategoryReadings(deviceIds, topic, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeasurementDevicesApi.measurementDeviceResourceDeviceCurrentCategoryReadings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceGeoMeasurementDevices(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.measurementDeviceResourceGeoMeasurementDevices(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeasurementDevicesApi.measurementDeviceResourceGeoMeasurementDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [includeDatasets]
         * @param {Array<number>} [tagObjectIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceGetMeasurementDevicesByTags(includeDatasets, tagObjectIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.measurementDeviceResourceGetMeasurementDevicesByTags(includeDatasets, tagObjectIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeasurementDevicesApi.measurementDeviceResourceGetMeasurementDevicesByTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.MeasurementDevicesApiFp = MeasurementDevicesApiFp;
/**
 * MeasurementDevicesApi - factory interface
 * @export
 */
const MeasurementDevicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MeasurementDevicesApiFp)(configuration);
    return {
        /**
         *
         * @param {MeasurementDevicesApiMeasurementDeviceResourceDeviceCurrentCategoryReadingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceDeviceCurrentCategoryReadings(requestParameters = {}, options) {
            return localVarFp.measurementDeviceResourceDeviceCurrentCategoryReadings(requestParameters.deviceIds, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceGeoMeasurementDevices(options) {
            return localVarFp.measurementDeviceResourceGeoMeasurementDevices(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MeasurementDevicesApiMeasurementDeviceResourceGetMeasurementDevicesByTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDeviceResourceGetMeasurementDevicesByTags(requestParameters = {}, options) {
            return localVarFp.measurementDeviceResourceGetMeasurementDevicesByTags(requestParameters.includeDatasets, requestParameters.tagObjectIds, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MeasurementDevicesApiFactory = MeasurementDevicesApiFactory;
/**
 * MeasurementDevicesApi - object-oriented interface
 * @export
 * @class MeasurementDevicesApi
 * @extends {BaseAPI}
 */
class MeasurementDevicesApi extends base_1.BaseAPI {
    /**
     *
     * @param {MeasurementDevicesApiMeasurementDeviceResourceDeviceCurrentCategoryReadingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementDevicesApi
     */
    measurementDeviceResourceDeviceCurrentCategoryReadings(requestParameters = {}, options) {
        return (0, exports.MeasurementDevicesApiFp)(this.configuration).measurementDeviceResourceDeviceCurrentCategoryReadings(requestParameters.deviceIds, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementDevicesApi
     */
    measurementDeviceResourceGeoMeasurementDevices(options) {
        return (0, exports.MeasurementDevicesApiFp)(this.configuration).measurementDeviceResourceGeoMeasurementDevices(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MeasurementDevicesApiMeasurementDeviceResourceGetMeasurementDevicesByTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementDevicesApi
     */
    measurementDeviceResourceGetMeasurementDevicesByTags(requestParameters = {}, options) {
        return (0, exports.MeasurementDevicesApiFp)(this.configuration).measurementDeviceResourceGetMeasurementDevicesByTags(requestParameters.includeDatasets, requestParameters.tagObjectIds, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MeasurementDevicesApi = MeasurementDevicesApi;
//# sourceMappingURL=measurement-devices-api.js.map